import { BFormInput, BFormGroup } from "bootstrap-vue";

export default {
  name: "BirthdaySettings",
  components: {
    BFormInput,
    BFormGroup,
  },

  data() {
    return {
      disabled: false,
      url: "admin/customers_club/get_birth_date_settings",
      editUrl: "admin/customers_club/set_birth_date_settings",
      items: {},
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.disabled = true;
      await this.$axios
        .get(this.url)
        .then((res) => {
          this.items = res.data.data.birth_date_settings;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    async submitChanges() {
      this.disabled = true;
      await this.$axios
        .post(this.editUrl, { ...this.items })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
